





















import { Component, Watch, Vue, Emit, Prop } from 'vue-property-decorator';
import { doublePrevention, institutionServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component
export default class ResultDepartDialog extends Vue {
  @Prop(String) private spaceId!: string;
  private visible = false;
  private type = '';
  private ruleIndex: any = '';
  private staffData: any = {};
  private title: any = '';
  private form: any = {
    staffList: [],
    form: '',
  };
  private _showOnce = false;
  private spaceIdChange: any = '';
  private spaceList: any = {};
  private companyData: any = [];
  private deptList: any = []; // 部门列表

  /**
   *【接口】获取部门
   * @Params
   * @return
   **/
  async getSpaceDeptList(opts: object) {
    try {
      const res: any = await institutionServer.getAllData(opts);
      if (res.code === '200') {
        const arr: any = arrayToTree(res.data);
        this.deptList = arr;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 处理首次打开窗口
   */
  async handleShowOnce() {
    if (this._showOnce) return;
    this._showOnce = true;
  }

  /**
   * 关闭窗口
   * @Params
   * @return
   **/
  hideDialog() {
    this.onResponse();
    this.staffData = {};
    this.resetForm();
    this.visible = false;

    // 刷新外部部门的列表数据
    setTimeout(() => {
      (this.$parent as any).getTableData();
      this.$forceUpdate();
    }, 200);
  }

  /**
   * 组织机构中的数据 键值对
   **/
  getCompanyById(data: any) {
    if (data.constructor === Array && data.length > 0) {
      data.forEach((item: any) => {
        if (item.id === this.spaceId) {
          this.companyData.push(item);
        } else {
          if (item.children && item.children.constructor === Array && item.children.length > 0) {
            this.getCompanyById(item.children);
          }
        }
      });
    }
  }

  handleClose(index: any, staff: any) {
    this.form.staffList.splice(index, 1); // 刪除
    this.form.name.splice(index, 1);
    console.log('this.form.name0', this.form.name);
    setTimeout(() => {
      this.form.name.forEach((item: any, index: any) => {
        this.$set(this.form.name, index, item);
      });
      console.log('this.form.name1', this.form.name);
    }, 200);
  }

  /**
   *【表单】表单重置
   * @Params
   * @return
   **/
  resetForm() {
    // const formComponent: any = this.$refs['form'];
    // formComponent.resetFields();
    this.form.departId = '';
    this.form.postId = '';
    this.form.staffName = '';
    this.form.name = '';
    this.form.staffList = [];
    this.spaceIdChange = '';
  }

  /**
   * 组织机构中的数据 键值对
   **/
  getObj(data: any) {
    if (data.constructor === Array && data.length > 0) {
      data.forEach((item: any) => {
        this.spaceList[item.id] = item.name;
        if (item.child && item.child.constructor === Array && item.child.length > 0) {
          this.getObj(item.child);
        }
      });
    }
  }

  /**
   * 【广播】广播提交成功事件
   * @Params
   * @return
   **/
  @Emit('on-response')
  onResponse() {
    return {
      index: this.ruleIndex,
      staff: this.form.staffList,
    };
  }

  /* 修改之后的事件 */
  private wholeData: any = {};

  private showDialog(data: any) {
    this.wholeData = data;
    this.visible = true;
    if (data.type === 'detail') {
      this.title = '隐患部门配置详情';
      this.getDetail(data);
      this.getSpaceDeptList({});
    } else if (data.type === 'edit') {
      this.title = '编辑隐患部门配置';
      this.getDetail(data);
      this.getSpaceDeptList({});
    }
  }

  /* 详情 */
  getDetail(data: any) {
    doublePrevention
      .getHazardLevelDepartmentConfigDetail({
        hazardLevel: data.data.hazardLevel || null,
        spaceId: data.data.spaceId || null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.changeObject(res.data.departmentMap); // 获取form.staffList
          this.changeObject11(res.data.departmentMap); // 获取form.staffList
        }
      });
  }

  /* 编辑 */
  modifyIt(data: any) {
    const needArr111: any = [];
    this.form.staffList.forEach((item: any) => {
      needArr111.push(item.id);
    });
    doublePrevention
      .modifyHazardLevelDepartmentConfig({
        hazardLevel: data.data.hazardLevel || null,
        spaceId: data.data.spaceId || null,
        departmentIdList: needArr111, // 部门id列表
      })
      .then((res: any) => {
        if (res.code === '200') this.$message.success('编辑成功！');
      });
  }

  /* 将接口的数据格式转成需要的数据格式 */
  changeObject(data: any) {
    const needArr = [];
    for (const key in data) {
      const obj: any = {
        id: key,
        name: data[key],
      };
      needArr.push(obj);
    }
    this.form.staffList = needArr;
  }

  /* 将接口的数据格式转成需要的数据格式 */
  changeObject11(data: any) {
    const needArr11 = [];
    for (const key in data) {
      needArr11.push(key);
    }
    this.form.name = needArr11;
  }

  /**
   *【按钮】提交按钮点击
   * @Params
   * @return
   **/
  handleSubmitBtnClick() {
    this.modifyIt(this.wholeData);
    this.hideDialog();
  }

  changData(data: any) {
    const delData = (this.$refs.cascader as any).getCheckedNodes()[0]; // 被删除的一项
    const indexData = (this.$refs.cascader as any).getCheckedNodes().indexOf(delData); // 是否含有这一项
    if (indexData !== -1) {
      setTimeout(() => {
        (this.$refs.cascader as any).getCheckedNodes().splice(indexData, 1);
        this.form.staffList = [];
        (this.$refs.cascader as any).getCheckedNodes().forEach((item: any) => {
          this.form.staffList.push({
            id: item.value,
            name: item.label,
          });
        });
      }, 200);
    }
  }
}
